export default __webpack_public_path__ + "static/media/buyWithClick.15480772.png";